module.exports = __webpack_public_path__ + "img/bagua.30cd213e.png";